module.exports = __webpack_public_path__ + "static/media/generator.03b93a2a.py";


//////////////////
// WEBPACK FOOTER
// ./src/game/maps/generator.py
// module id = 100
// module chunks = 0